import { useState, useEffect } from "react";
import { isFunction } from "@util/utils";

/**
 * 自定義 Hook 用於管理選項數據的獲取和狀態
 *
 * @param {Object} params - 參數物件
 * @param {Function} params.getOptionsApi - 用於獲取選項數據的 API 函數，應返回一個 Promise
 * @param {boolean} [params.isFetchOnMount=false] - 是否在組件掛載時自動獲取選項數據
 * @returns {Object} 包含選項數據和重新獲取函數的物件
 * {
 *   options: Object, // 當前的選項數據
 *   getOptionsApi: Function, // 重新獲取選項數據的函數
 * }
 */
const useOptions = ({ getOptionsApi, isFetchOnMount = false }) => {
	const [options, setOptions] = useState({});

	const fetchOptions = async (...args) => {
		try {
			const resp = await getOptionsApi(...args);
			if (resp) setOptions(resp);
		} catch (error) {
			console.error("Failed to fetch options:", error);
			setOptions({});
		}
	};

	useEffect(
		() => {
			if (isFunction(getOptionsApi) && isFetchOnMount) fetchOptions();
		},
		// eslint-disable-next-line
		[isFetchOnMount],
	);

	return {
		options,
		getOptionsApi: fetchOptions,
	};
};

export default useOptions;
